import React, { Component } from 'react';
import '../../../App.css';
import '../../../styles/app-demo.css';
import CurrencyInput from 'react-currency-input';

class PayAmount extends Component {

  constructor(props){
    super(props)
    this.state = {
     amount: 0.00
    }
    this.handleAmount = this.handleAmount.bind(this);
    this.submitAmount = this.submitAmount.bind(this);
  }

  handleAmount(event) {
    this.setState({
      amount: event.target.value
    })
  }

  submitAmount() {
    this.props.submitAmount(this.state.amount)
    this.props.handleBillPayRoute('payment frequency')
  }

  render() {

    return (
      <div className="fintwist-interactive-mobile">
        <section className="mobile-app-wrapper">
          <div className="orange-header">
            <i onClick={() => this.props.handleBillPayRoute('select payee')} className="fa fa-angle-left"></i>
            <h2>Enter Amount</h2>
          </div>
        <div className="mobile-app-dashboard">
          <ul id="pay-amount-list-header" className="app-list">
              <li>
                <div className="app-list-pre-row">
                  <p>From Account</p>
                </div>
              </li>
              <li>
                <div id="pay-amount-row-1" className="app-list-row-1">
                  <p>Fintwist Account</p>
                  <p>$1,001.97</p>
                </div>
              </li>
              <li>
                <div id="pay-amount-row-2" className="app-list-row-2">
                  <p>Comdata</p>
                  <p>Available Balance</p>
                </div>
              </li>
            </ul>
            <div className="amount-wrapper">
              <p>Amount</p>
              <CurrencyInput prefix="$" value={this.state.amount} onChangeEvent={this.handleAmount}/>
              <button className="bill-pay-button" onClick={this.submitAmount}>CONTINUE</button>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default PayAmount;
